import { createContext, Dispatch, SetStateAction } from 'react'
import { segmentedControlSizes } from '@shared/config/components/segmentedControl'

type SizeValue = keyof typeof segmentedControlSizes

type ResponsiveSize = SizeValue | { mobile: SizeValue; desktop: SizeValue }

interface SegmentedControlContextType {
  size: ResponsiveSize
  activeItemIndex: number
  setActiveItemIndex: Dispatch<SetStateAction<number>> | null
}

export const SegmentedControlContext = createContext<SegmentedControlContextType>({
  size: 'm',
  activeItemIndex: 0,
  setActiveItemIndex: null,
})
